'use strict'

function initializeInquery() {
  $(document).ready(function(){
    // Click event for continent
    $('.inquery__form-group--continent input').click(function() {
      let $val = $(this).val()
      if ($val != undefined) {
        $('.inquery__result').removeClass('active')
        $('.inquery__list').removeClass('active')
        $('.inquery__list[rel="' + $val + '"]').addClass('active')
      }
    });
    // Click event for country
    $('.inquery__form-group--country input').click(function() {
      let $val = $(this).val()
      if ($val != undefined) {
        $('.inquery__result').removeClass('active')
        $('.inquery__result[rel="' + $val + '"]').addClass('active')
      }
    });
  });
}

export default initializeInquery
